import { GetPaymentLinksQuery, GetPaymentLinksQueryVariables } from '@/types';
import { gql, NetworkStatus } from '@apollo/client';
import { useWrappedQuery } from '@/hooks/use-wrapped-query';

export const GET_PAYMENT_LINKS_QUERY = gql`
  query GetPaymentLinks($restaurant_id: uuid!, $supplier_id: uuid!) {
    getPaymentLinks(restaurant_id: $restaurant_id, supplier_id: $supplier_id) {
      payment_links {
        credit_memos_count
        id
        invoices_count
        payment_link {
          created_at
        }
        payment_link_url
        total_remaining_balance_in_micros
      }
    }
  }
`;

export const useGetPaymentLinks = (
  restaurant_id: string,
  supplier_id: string,
  skip: boolean,
) => {
  const { data, error, hasResponse, loading, networkStatus, refetch } =
    useWrappedQuery<GetPaymentLinksQuery, GetPaymentLinksQueryVariables>(
      GET_PAYMENT_LINKS_QUERY,
      {
        fetchPolicy: 'cache-and-network',
        notifyOnNetworkStatusChange: true,
        skip,
        variables: { restaurant_id, supplier_id },
      },
    );

  return {
    error,
    hasResponse,
    loading,
    paymentLinks: data?.getPaymentLinks.payment_links || [],
    refresh: async () => {
      await refetch();
    },
    refreshing: networkStatus === NetworkStatus.refetch,
  };
};
